<template>
  <div class="meta"></div>
</template>
<script setup lang="ts">
import { watchEffect } from 'vue'
import { setHead } from './head'

const props = defineProps<{ title?: string }>()

watchEffect(() => {
  setHead(props)
})
</script>
<style>
.meta {
  display: none;
}
</style>
